import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4d18180a&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=4d18180a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d18180a",
  null
  
)

export default component.exports